/**
 * Utilitaires pour la gestion des images
 */

/**
 * Obtient l'URL complète du backend
 */
export const getBackendUrl = (): string => {
  // En développement, pointer vers le backend directement
  const apiBase = import.meta.env.VITE_API_BASE_URL as string | undefined;
  
  if (apiBase && /^https?:\/\//i.test(apiBase)) {
    // Si c'est une URL absolue, extraire l'origine
    try {
      const url = new URL(apiBase);
      return url.origin;
    } catch {
      return 'http://localhost:8000';
    }
  }
  
  // En production avec proxy nginx, utiliser l'origine actuelle
  // Cela fonctionne aussi pour Docker (localhost:8014)
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  
  return 'http://localhost:8000';
};

/**
 * Construit l'URL complète d'une image uploadée
 * @param path - Chemin relatif de l'image (ex: "/uploads/employees/123_abc.jpg")
 * @returns URL complète vers l'image sur le backend
 */
export const getImageUrl = (path: string | null | undefined): string => {
  if (!path) {
    return '/default-avatar.svg';
  }
  
  // Si c'est déjà une URL complète, la retourner telle quelle
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  
  // Construire l'URL complète vers le backend
  const backendUrl = getBackendUrl();
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  
  return `${backendUrl}${cleanPath}`;
};

/**
 * Obtient l'URL de l'avatar d'un employé avec fallback
 * @param profilePicture - Chemin de la photo de profil
 * @returns URL de l'image ou avatar par défaut
 */
export const getEmployeeAvatarUrl = (profilePicture: string | null | undefined): string => {
  return getImageUrl(profilePicture);
};
